<template>
    <transition name="sidemenu-slider">
        <div v-if="sliderOpen" id="sidemenu" class="sidemenu fast" :class="{'full-height': fullHeight}">
            <div v-if="!loading" class="flex-wrapper">
                <div class="flex-topbar">
                    <div class="close-button" @click="closeMenu()">
                        <span aria-hidden="true">×</span>
                    </div>
                    <div class="grid-x">
                        <div class="large-10 topbar-asset-info medium-7 small-6 cell flexbox-center-left">
                            <h3><span>Aktiv</span></h3>
                            <div class="flex-row">
                                <div class="flex">
                                    <div class="flex-row">
                                        <div class="flex-column">
                                            <span>Idrifttagningsdato:</span>
                                            <span>Afgangsdato:</span>
                                            <span>Projekt:</span>
                                        </div>
                                        <div class="flex-column spacing">
                                            <span><b>{{sliderData && sliderData.iDriftTagningsDato ? sliderData.iDriftTagningsDato : 'Ingen dato' | formatDate}}</b></span>
                                            <span><b>{{sliderData && sliderData.afgangsdato ? sliderData.afgangsdato : 'Ingen dato' | formatDate}}</b></span>
                                            <span><b>{{sliderData && sliderData.project ? sliderData.project.navn : 'Intet navn'}}</b></span>
                                        </div>
                                    </div>
                                </div>
                                <div class="flex spacing">
                                    <div class="flex-row">
                                        <div class="flex-column">
                                            <span>Kategorinavn:</span>
                                            <span>Beskrivelse:</span>
                                        </div>
                                        <div class="flex-column spacing">
                                            <span><b>{{sliderData && sliderData.kategoriNavn ? sliderData.kategoriNavn : 'Intet navn'}}</b></span>
                                            <span class="wrap-text"><b>{{sliderData && sliderData.beskrivelse ? sliderData.beskrivelse : 'Ingen beskrivelse'}}</b></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex-middle body-slider">
                    <div class="body-content-top">
                        <div class="grid-x">
                            <div class="auto cell flexbox-center-left-select">
                                <span>Balance:</span>
                                <select v-model="selectedBalanceId" id="select-template">
                                    <option value="" disabled="disabled">Vælg balance i listen</option>
                                    <option v-for="balance in regnskabSetting" :selected="balance.beskrivelse" v-bind:key="balance.id" :value="balance.id">
                                        {{balance.beskrivelse}}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex-content">
                    <div v-if="sliderData && sliderData.aktivPosts && sliderData.aktivPosts.length > 0" class="grid-x list-sort compact non-sortable">
                        <div class="large-1 cell flexbox-center"></div>
                        <div class="large-11 cell">
                            <div class="grid-x" style="padding-right: 10px;">
                                <div class="large-3 cell item flexbox no-margin">
                                    <span>Dato</span>
                                </div>
                                <div class="large-5 cell item flexbox no-margin">
                                    <span>Beskrivelse</span>
                                </div>
                                <div class="large-2 cell item flexbox no-margin flex-end">
                                    <span>Værdi</span>
                                </div>
                                <div class="large-2 cell item flexbox no-margin flex-end">
                                    <span>Sum</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="sliderData && sliderData.aktivPosts && sliderData.aktivPosts.length > 0" class="body-content">
                        <div v-for="aktiv in sliderData.aktivPosts" :key="aktiv.id" class="grid-x list">
                            <div class="large-3 cell flexbox-align-items">
                                {{aktiv.registreringsDato | formatDate}}
                            </div>
                            <div class="large-5 cell flexbox-align-items">
                                {{aktiv.tekst}}
                            </div>
                            <div class="large-2 cell flexbox-align-items flex-end">
                                {{aktiv.vaerdi | convertToLocalStringDK}} kr.
                            </div>
                            <div class="large-2 cell flexbox-align-items flex-end">
                                {{calcSum(aktiv) | convertToLocalStringDK}} kr.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else class="loading-div">
                <h1 class="loading-header">Henter aktiv...</h1>
            </div>
        </div>
    </transition>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from '@/store/api.js'

export default {
    name: 'project-slider',
    props: {
        sliderOpen: Boolean,
        selectedAsset: Object,
        fullHeight: Boolean
    },
    data () {
        return {
            sliderData: null,
            loading: false
        }
    },
    computed: {
        ...mapGetters({
            regnskabSetting: 'getRegnskabSetting'
        }),
        selectedBalanceId: {
            get () {
                return this.$store.getters.getSelectedBalance.id
            },
            async set (value) {
                const selectedRegnskab = this.regnskabSetting.find(r => r.id === value)
                if (selectedRegnskab) {
                    this.$store.state.global.selectedBalance = selectedRegnskab
                }

                try {
                    await this.getSliderData()
                } catch (err) {
                    console.log('error getting priceMeter', err)
                }
            }
        }
    },
    methods: {
        closeMenu () {
            this.$emit('toggleSlider', false)
        },
        async getSliderData () {
            if ((this.selectedAsset && this.selectedAsset.id) || (this.selectedAsset && this.selectedAsset.aktivId)) {
                this.loading = true
                const response = await axios.post('/Value/Aktiv/ReadAktivDetails', {
                    id: this.selectedAsset.aktivId ? this.selectedAsset.aktivId : this.selectedAsset.id,
                    balanceId: this.selectedBalanceId
                })
                if (response) {
                    this.loading = false
                    if (response.data.aktivPosts) {
                        const sortedAktivPosts = response.data.aktivPosts.sort((a, b) => {
                            if (a.registreringsDato < b.registreringsDato) {
                                return -1
                            }
                            if (a.registreringsDato > b.registreringsDato) {
                                return 1
                            }
                            if (a.registreringsDato === b.registreringsDato) {
                                if (a.sortering < b.sortering) {
                                    return -1
                                }
                                if (a.sortering > b.sortering) {
                                    return 1
                                }
                                return 0
                            }
                            return 0
                        })
                        response.data.aktivPosts = sortedAktivPosts
                    }
                    this.sliderData = response.data
                }
            } else {
                this.loading = false
            }
        },
        calcSum (aktiv) {
            let sum = 0
            let stopAtIndex = null
            if (this.sliderData && this.sliderData.aktivPosts) {
                this.sliderData.aktivPosts.forEach((post, index) => {
                    if (stopAtIndex === null) {
                        if (post === aktiv) {
                            stopAtIndex = index
                        }
                        sum += post.vaerdi
                    }
                })
            }
            return sum
        }
    },
    watch: {
        selectedAsset (val, oldVal) {
            if (val && oldVal) {
                if (val.id !== oldVal.id) {
                    this.getSliderData()
                }
            } else {
                if (val && val.id) {
                    this.getSliderData()
                }
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.flex-wrapper {
    display: flex;
    flex-direction: column;
    height: 100%;

    .flex-topbar {
        position: relative;
        background-color: #ffffff;
        color: #424242;
        border-bottom: 1px solid #efeded;
        padding-bottom: 5px;
        padding-top: 0px;
    }

    .flex-content {
        flex: 1 0 0;
        display: flex;
        flex-direction: column;
    }
}

.flex-row {
    display: flex;
    flex-direction: row;
    height: 100%;

    .flex {
        flex: 0 0 auto;

        &.spacing {
            padding-left: 10px;
        }
    }

    .flex-column {
        display: flex;
        flex: 0 0 auto;
        flex-direction: column;

        &.spacing {
            padding-left: 10px;
        }
    }
}

.flex-end {
    display: flex;
    justify-content: flex-end;
}

.wrap-text {
    display: block;
    width: 300px;
    word-wrap: break-word;
}
</style>


// WEBPACK FOOTER //
// src/components/page/project/project-slider.vue